import React from 'react'
import { Controller } from 'react-hook-form'
import UserFormField from '../UserFormField'
import { useFormContextUser } from '../utils/_utils'
import { useGetIdsReferencesSpementions } from '@toktokdoctech/tokapi-client'
import { computeOptions } from '../utils/computeData'

const MentionsAndTitles = () => {
    const { control, watch } = useFormContextUser()

    const professionId = watch('professionId')

    const { data, isLoading, error } = useGetIdsReferencesSpementions(
        {
            professionId,
        },
        {
            query: {
                enabled: Boolean(professionId),
            },
        },
    )
    const computedRelatedSpeMentions = React.useMemo(() => {
        if (data) {
            return computeOptions(data)
        }
        return undefined
    }, [data])

    if (error) {
        console.error(error)
        return null
    }

    return (
        <Controller
            control={control}
            name="speMentions"
            render={({ field, fieldState: { error } }) => {
                const selectedNames = field.value.map((m) => m.name)
                return (
                    <UserFormField
                        variant="select"
                        label="Titres et mentions"
                        type="multiple"
                        name={field.name}
                        status={{
                            error,
                            valid: field.value.length > 0,
                        }}
                        disabled={!professionId}
                        value={selectedNames}
                        noValueText="Ajouter un ou plusieurs titre(s) et mention(s)"
                        options={computedRelatedSpeMentions ?? []}
                        onChange={(names) => {
                            field.onChange(
                                (names ?? []).map((name) => ({
                                    id: computedRelatedSpeMentions?.find((o) => o.value === name)?.id ?? '',
                                    name,
                                })),
                            )
                        }}
                        renderLabel={() => {
                            if (isLoading) {
                                return 'Chargement des titres et mentions...'
                            }

                            return selectedNames.length > 0 ? selectedNames.join(', ') : undefined
                        }}
                    />
                )
            }}
        />
    )
}

export default MentionsAndTitles
